import { Result } from "antd"

const AccesoProhibido = ()=>{
    return <Result  status="403"
    title="403"
    subTitle="Lo siento, no estas autorizado para acceder a esta sección."/>
}

export default AccesoProhibido